// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"ProfileEdit_text-gradient__2OjlW","top":"ProfileEdit_top__3NuR1","title":"ProfileEdit_title__p3K6a","info":"ProfileEdit_info__3_WK7"};